import i18n from "@/modules/localization/i18n";
import store from "@/store/store";
import Vue from "vue";

//ay bazlı çalışır
Vue.filter("period", function(months = 12) {
  const years = Math.floor(months / 12);
  const modMonths = months % 12;
  if (years == 0 && modMonths == 0) {
    return `${years} ` + i18n.t("common.year");
  }

  let period = "";

  if (years > 0) {
    period += `${years} ` + i18n.t("common.year") + " ";
  }

  if (modMonths > 0) {
    period += `${modMonths} ` + i18n.t("common.month") + " ";
  }

  return period.trim();

  /*
 //Yıl bazlı 
 const years = Math.floor(value / 365);
  const months = Math.floor((value % 365) / 30);
  const days = value % 30;

  if (value % 365 == 0) {
    return `${years} ` + i18n.t("common.year");
  }

  let period = "";

  if (years > 0) {
    period += `${years} ` + i18n.t("common.year") + " ";
  }

  if (months > 0) {
    period += `${months} ` + i18n.t("common.month") + " ";
  }

  if (days > 0) {
    period += `${days} ` + i18n.t("common.day") + " ";
  }

  return period.trim();
 */
});

Vue.filter("addMonth", function addMonth(date, value = 1) {
  value = Number(value);
  date = date || new Date();
  const mutation = new Date(date.getTime());
  mutation.setMonth(mutation.getMonth() + value);
  return mutation;
});

Vue.filter("translate", (value) => {
  if (typeof value == "string") {
    return value;
  }
  if (value) {
    return value[store.getters["user/account"].language];
  }
  return value;
});

Vue.filter("regulation", (value) => {
  if (typeof value == "string") {
    return value;
  }
  const product = store.getters["product/currentProduct"];
  if (product == "KVKK") {
    return value.kvkkRegulation;
  } else {
    return value.gdprRegulation;
  }
});

Vue.filter("web", (value) => {
  if (typeof value === "string") {
    if (!value.startsWith("http")) {
      return "http://" + value;
    }
  }
  return value;
});

Vue.filter("date", (value, withTime = false) => {
  if (!value) {
    return null;
  }
  const date = new Date(value);
  return date.toLocaleDateString("tr") + (withTime ? " " + date.toLocaleTimeString("tr") : "");
});

Vue.filter("isoWeek", (value) => {
  if (!value) {
    return null;
  }
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return null;
  }
  const target = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNumber = (target.getUTCDay() + 6) % 7;
  target.setUTCDate(target.getUTCDate() - dayNumber + 3);
  const firstThursday = new Date(Date.UTC(target.getUTCFullYear(), 0, 4));
  const firstThursdayDayNumber = (firstThursday.getUTCDay() + 6) % 7;
  firstThursday.setUTCDate(firstThursday.getUTCDate() - firstThursdayDayNumber + 3);
  return 1 + Math.round((target - firstThursday) / (7 * 24 * 60 * 60 * 1000));
});

Vue.filter("formatByte", function(value) {
  if (value >= 1024 * 1024 * 1024) {
    return (value / (1024 * 1024 * 1024)).toFixed(1) + " GB";
  } else if (value >= 1024 * 1024) {
    return (value / (1024 * 1024)).toFixed(1) + " MB";
  } else if (value >= 1024) {
    return (value / 1024).toFixed(0) + " KB";
  } else {
    return 0 + " KB";
  }
});

Vue.filter("summary", (value, limit = 30) => {
  if (!value) {
    return value;
  }

  return value.replace(/<[^>]*>?/gm, "").substr(0, limit) + (value.length > limit ? "..." : "");
});

Vue.filter("number", (value) => {
  if (!value) {
    return value;
  }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};
